// Routen der Oberfläche. Seiten liegen in src/pages (feste Dateinamen, siehe crm/ZUSTAENDIGKEIT.md).
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { AppLayout } from "./components/AppLayout";
import { lazySeite } from "./components/LazySeite";
import { MeldungenProvider } from "./components/Meldungen";
import { setzeErgebnisFormular } from "./components/TelefonieTeile";
import { NachAnrufFormular } from "./components/lead/NachAnrufFormular";
import Inbox from "./pages/Inbox";
import Lead from "./pages/Lead";
import Login from "./pages/Login";
import SmartView from "./pages/SmartView";
import { TelefonieProvider } from "./telefonie";

// Selten gebrauchte Seiten laden erst beim Öffnen (siehe components/LazySeite.tsx); Posteingang, Smart View, Lead und Login bleiben im Start.
const Aktivitaeten = lazySeite(() => import("./pages/Aktivitaeten"));
const Berichte = lazySeite(() => import("./pages/Berichte"));
const Dubletten = lazySeite(() => import("./pages/Dubletten"));
const Gespraeche = lazySeite(() => import("./pages/Gespraeche"));
const Einstellungen = lazySeite(() => import("./pages/Einstellungen"));
const Kontakte = lazySeite(() => import("./pages/Kontakte"));
const Leads = lazySeite(() => import("./pages/Leads"));
const Opportunities = lazySeite(() => import("./pages/Opportunities"));
const SmartViews = lazySeite(() => import("./pages/SmartViews"));
const Workflows = lazySeite(() => import("./pages/Workflows"));

// Nach dem Anruf trägt das Telefon-Feld das Ergebnis mit dem Custom-Activity-Formular der Oberfläche ein.
setzeErgebnisFormular?.(NachAnrufFormular);

// Die zwei häufigsten der nachgeladenen Seiten schon im Leerlauf holen, damit der erste Klick darauf nicht auf das Netz wartet.
if (typeof window !== "undefined") {
  const vorladen = () => {
    void import("./pages/SmartViews");
    void import("./pages/Leads");
  };
  const mitLeerlauf = (window as Window & { requestIdleCallback?: (f: () => void, o?: { timeout: number }) => number }).requestIdleCallback;
  if (mitLeerlauf) mitLeerlauf.call(window, vorladen, { timeout: 8000 });
  else window.setTimeout(vorladen, 4000);
}

export default function App() {
  return (
    <AuthProvider>
      <MeldungenProvider>
        <TelefonieProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<AppLayout />}>
              <Route index element={<Navigate to="/inbox" replace />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/smart-views" element={<Navigate to="/smart-views/alle" replace />} />
              <Route path="/smart-views/alle" element={<SmartViews art="alle" />} />
              <Route path="/smart-views/eigene" element={<SmartViews art="eigene" />} />
              <Route path="/smart-views/geteilt" element={<SmartViews art="geteilt" />} />
              <Route path="/smart-views/andere" element={<SmartViews art="andere" />} />
              <Route path="/smart-views/:viewId" element={<SmartView />} />
              <Route path="/lead/:leadId" element={<Lead />} />
              {/* Einstellungen: zweite Navigationsspalte, Unterseiten (pages/einstellungen/seiten.ts) */}
              <Route path="/einstellungen/*" element={<Einstellungen />} />
              {/* Workflows (Agent 4C): Liste, Editor und Läufe legt die Seite mit eigenen Unterrouten an */}
              <Route path="/workflows/*" element={<Workflows />} />
              {/* Runde 5: Seiten der Agenten 5C (Kontakte, Aktivitäten) und 5D (Opportunities), mit eigenen Unterrouten */}
              <Route path="/kontakte" element={<Kontakte />} />
              <Route path="/aktivitaeten/*" element={<Aktivitaeten />} />
              <Route path="/opportunities/*" element={<Opportunities />} />
              {/* Runde 7: Seiten der Agenten 7A (Berichte), 7D (Gespräche) und 7C (Dubletten), mit eigenen Unterrouten */}
              <Route path="/reports/*" element={<Berichte />} />
              <Route path="/gespraeche/*" element={<Gespraeche />} />
              <Route path="/dubletten" element={<Dubletten />} />
              <Route path="*" element={<Navigate to="/inbox" replace />} />
            </Route>
          </Routes>
        </TelefonieProvider>
      </MeldungenProvider>
    </AuthProvider>
  );
}
